import React, { Component } from 'react';
import Breadcrumb from './breadcrumb';
import { Button } from 'react-bootstrap';
import { getSettings, updateSettings } from '../../../services/clinicPortalServices/settingService';
import { FormGroup, FormControlLabel, Switch, TextField, MenuItem } from '@mui/material';
import toastr from 'toastr';
import { specimenTypes } from '../../../services/common/optionsData';

class ClinicConfigurationss extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: [],
            is_show_diagnosis_code_for_tests_create_requisition: false,
            is_show_diagnosis_code_for_medications_create_requisition: false,
            is_show_collector_name_create_requisition: false,
            is_using_internal_sample: false,
            is_using_analyte_abbreviation_column_import: false,
            default_specimen_type: ''
        };
    }

    componentDidMount() {
        getSettings().then((response) => {
            if (response && response.data) {
                this.setState({
                    is_show_diagnosis_code_for_tests_create_requisition:
                        response.data.is_show_diagnosis_code_for_tests_create_requisition,
                    is_show_diagnosis_code_for_medications_create_requisition:
                        response.data.is_show_diagnosis_code_for_medications_create_requisition,
                    is_show_collector_name_create_requisition: response.data.is_show_collector_name_create_requisition,
                    default_specimen_type: response.data.default_specimen_type,
                    is_using_internal_sample: response.data.is_using_internal_sample,
                    is_using_analyte_abbreviation_column_import:
                        response.data.is_using_analyte_abbreviation_column_import
                });
            }
        });
    }

    handleSwitchChange = (e) => {
        let info = {
            [e.target.name]: e.target.checked
        };
        updateSettings(info).then((response) => {
            if (response.status === 200) {
                toastr.success(response.message);
            }
        });
        this.setState({ [e.target.name]: e.target.checked });
    };

    handleChange = (e) => {
        const info = {
            [e.target.name]: e.target.value
        };
        updateSettings(info).then((response) => {
            if (response.status === 200) {
                toastr.success(response.message);
            }
        });
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    render() {
        return (
            <div className="clinic-contain">
                <Breadcrumb />
                <div className="px-5 py-3">
                    <div className="row">
                        <div className="col-12 col-md-6 d-flex flex-column mt-3">
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            onChange={this.handleSwitchChange}
                                            checked={this.state.is_show_diagnosis_code_for_tests_create_requisition}
                                            name="is_show_diagnosis_code_for_tests_create_requisition"
                                        />
                                    }
                                    label="Show Diagnosis Code for Tests when Create Requisition"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            onChange={this.handleSwitchChange}
                                            checked={
                                                this.state.is_show_diagnosis_code_for_medications_create_requisition
                                            }
                                            name="is_show_diagnosis_code_for_medications_create_requisition"
                                        />
                                    }
                                    label="Show Diagnosis Code for Medications when Create Requisition"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            onChange={this.handleSwitchChange}
                                            checked={this.state.is_show_collector_name_create_requisition}
                                            name="is_show_collector_name_create_requisition"
                                        />
                                    }
                                    label="Show Name of Collector when Create Requisition"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            onChange={this.handleSwitchChange}
                                            checked={this.state.is_using_internal_sample}
                                            name="is_using_internal_sample"
                                        />
                                    }
                                    label="Uses Internal Sample"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            onChange={this.handleSwitchChange}
                                            checked={this.state.is_using_analyte_abbreviation_column_import}
                                            name="is_using_analyte_abbreviation_column_import"
                                        />
                                    }
                                    label="Uses Analyte Abbreviation Column Result Import?"
                                />
                            </FormGroup>
                        </div>
                        <div className="col-12 col-md-6 mt-3">
                            <label className="mb-3">Default Specimen Type</label>
                            <div className="form-group">
                                <TextField
                                    select
                                    label="Specimen Type *"
                                    name="default_specimen_type"
                                    value={this.state.default_specimen_type}
                                    onChange={this.handleChange}
                                >
                                    {specimenTypes.map((specimenType) => {
                                        return (
                                            <MenuItem value={specimenType} key={specimenType}>
                                                {specimenType}
                                            </MenuItem>
                                        );
                                    })}
                                </TextField>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ClinicConfigurationss;
